import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

type Size = 'sm' | 'md' | 'lg';

export interface NbCardProps extends HTMLAttributes<HTMLDivElement> {
  size?: Size;
}

const SIZE_CLASS: Record<Size, string> = {
  sm: 'nb-sm',
  md: 'nb',
  lg: 'nb-lg',
};

export const NbCard = forwardRef<HTMLDivElement, NbCardProps>(
  ({ size = 'md', className, ...rest }, ref) => (
    <div ref={ref} className={cn(SIZE_CLASS[size], 'overflow-hidden', className)} {...rest} />
  ),
);
NbCard.displayName = 'NbCard';
